import axios from "axios";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import stc from "string-to-color";
import { config } from "@/core/config";
import {
  Module,
  Actions,
  Mutations,
  Getters,
  Params,
} from "@/store/enums/participationEnums";

import inveteAvailableTimeModel from "@/core/models/share/inviteAvailableTime.interface";
import voteEventModel from "@/core/models/share/voteEvent.interface";
import voteEventCountModel from "@/core/models/share/voteEventCount.interface";
import statusModel from "@/core/models/share/status.interface";
import inviteEventModel from "@/core/models/share/inviteEvent.interface";
import inviteSchedulerModel from "@/core/models/share/inviteAvailableTime.interface";
import timelineRowGroupHeaderModel from "@/core/models/share/timeline/rowGroupHeader.interface";
import timelineRowHeaderModel from "@/core/models/share/timeline/rowHeader.interface";
import timelineElmtModel from "@/core/models/share/timeline/timelineItem.interface";
import invitePersonModel from "@/core/models/share/invitePerson.interface";

import {
  EventStatus as ParamEventStatus,
  ParticapantStatus as ParamParticapantStatus,
  ResponseStatus as ParamResponseStatus,
  IsResolution as ParamIsResolution,
  HasReply as ParamHasReply,
} from "@/store/enums/paramsEnums";
import apiEnums from "@/core/services/apiEnums";

import ApiService from "@/core/services/ApiService";

const participationModules = {
  namespaced: true,
  state() {
    return {
      //所有參與事件的選項
      MyParticipationEventsAvailableTimes:
        new Array<inveteAvailableTimeModel>(),
      //所有參與事件中我的回應
      MyParticipationEventsResponses: new Array<voteEventModel>(),
      //指定事件中各選項與統計資訊
      EventSchedularCountWithMyResponse: new Array<voteEventCountModel>(),
      // 取得事件單一參與人員狀態
      EventPartRespStatus: new Array<invitePersonModel>(),

    };
  },

  mutations: {
    [Mutations.SetEventsAvailableTimes](
      context: any,
      payload: Array<inveteAvailableTimeModel>
    ) {
      context.MyParticipationEventsAvailableTimes = payload;
    },
    [Mutations.SetEventsMyResponses](
      context: any,
      payload: Array<voteEventModel>
    ) {
      context.MyParticipationEventsResponses = payload;
    },
    [Mutations.SetEventSchedularCountWithMyResponse](
      context: any,
      payload: Array<voteEventCountModel>
    ) {
      context.EventSchedularCountWithMyResponse = payload;
    },
    [Mutations.SetEventPartRespStatus](
      context: any,
      payload: Array<invitePersonModel>
    ) {
      context.EventPartRespStatus = payload;
    },
    [Mutations.SetUserVote](context: any, payload: any) {
      var objIndex = context.MyParticipationEventsResponses.findIndex(function (
        obj: voteEventModel
      ) {
        return (
          obj.EventHeaderId == payload.EventHeaderId &&
          obj.EventScheduleId == payload.EventScheduleId &&
          obj.EventParticipantId == payload.EventParticipantId
        );
      });
      if (objIndex >= 0) {
        context.MyParticipationEventsResponses[objIndex].Status =
          payload.Status;
      } else {
        context.MyParticipationEventsResponses.push(payload);
      }
    },
  },

  actions: {
    async [Actions.LoadEventsAvailableTime](context: any, payload: any) {
      var endPoint =
        config.apiEndPoints.jma +
        apiEnums.GetAllParticipantEventSchedularByUser.Path;
      var memberid = context.rootState.user.MemberId;

      await axios
        .get(
          endPoint.replace(
            apiEnums.GetAllParticipantEventSchedularByUser.Params.memberid,
            memberid
          )
        )
        .then((response) => {
          // console.log("response: ", response.data);
          // console.log("----------------------------------------");
          context.commit(Mutations.SetEventsAvailableTimes, response.data);
        })
        .catch((error: any) => {
          console.log({
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
          });
        });
    },
    async [Actions.LoadEventsMyResponses](context: any, payload: any) {
      var endPoint =
        config.apiEndPoints.jma +
        apiEnums.GetAllParticipantEventResponseByUser.Path;
      var memberid = context.rootState.user.MemberId;

      await axios
        .get(
          endPoint.replace(
            apiEnums.GetAllParticipantEventResponseByUser.Params.memberid,
            memberid
          )
        )
        .then((response) => {
          // console.log("response: ", response.data);
          // console.log("----------------------------------------");

          context.commit(Mutations.SetEventsMyResponses, response.data);
        })
        .catch((error: any) => {
          console.log({
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
          });
        });
    },
    async [Actions.LoadEventSchedularCountWithMyResponse](
      context: any,
      eventid: string
    ) {
      var endPoint: string =
        config.apiEndPoints.jma + apiEnums.GetEventSchedularSummaryByUser.Path;
      var memberid = context.rootState.user.MemberId;
      eventid = eventid.toUpperCase();

      await axios
        .get(
          endPoint
            .replace(
              apiEnums.GetEventSchedularSummaryByUser.Params.eventid,
              eventid
            )
            .replace(
              apiEnums.GetEventSchedularSummaryByUser.Params.memberid,
              memberid
            )
        )
        .then((response) => {
          context.commit(
            Mutations.SetEventSchedularCountWithMyResponse,
            response.data
          );
        })
        .catch((error: any) => {
          console.log({
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
          });
        });

      var resId: string = context.state.EventSchedularCountWithMyResponse[0].EventParticipantId
      //console.log("resId",resId);
      endPoint = config.apiEndPoints.jma + apiEnums.GetEventParticipantStatus.Path;

      await axios
        .get(
          endPoint
            .replace(
              apiEnums.GetEventParticipantStatus.Params.participantid,
              resId
            )
        )
        .then((response) => {
          context.commit(
            Mutations.SetEventPartRespStatus,
            response.data
          );
        })
        .catch((error: any) => {
          console.log({
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
          });
        });



    },
    async [Actions.HandMyEventVote](context: any, payload: any) {
      var eventId = payload.EventHeaderId;
      var eventResponseId = payload.ParticipantResponseId;
      var endPoint = "";

      if (eventResponseId == "") {
        endPoint = config.apiEndPoints.jma + apiEnums.PostNewEventResponse.Path;
        await axios
          .post(
            endPoint.replace(
              apiEnums.PostNewEventResponse.Params.eventid,
              eventId
            ),
            payload
          )
          .then((response) => {
            if (~~(response.status / 100) == 2) {
              // console.log("----------------------------------------");
              // console.log("Update Success:", payload.Status == ParamEventStatus.Open ? "Yes" : "No");
              context.commit(Mutations.SetUserVote, payload);
            }
          })
          .catch((error: any) => {

            console.log({
              endpoint: endPoint,
              path: endPoint.replace(config.apiEndPoints.jma, ""),
              request: payload,
              // request: ApiService.removeIndicateProperties(payload, [
              //   "ParticipantResponseId",
              // ]),
            });
          });

      } else {
        endPoint = config.apiEndPoints.jma + apiEnums.PutEventResponse.Path;
        await axios
          .put(
            endPoint.replace(
              apiEnums.PutEventResponse.Params.responseid,
              eventResponseId
            ),
            payload
          )
          .then((response) => {
            if (~~(response.status / 100) == 2) {
              // console.log("----------------------------------------");
              // console.log("Update Success:", payload.Status == ParamEventStatus.Open ? "Yes" : "No");
              context.commit(Mutations.SetUserVote, payload);
            }
          })
          .catch((error: any) => {

            console.log({
              endpoint: endPoint,
              path: endPoint.replace(config.apiEndPoints.jma, ""),
              request: payload,
            });
          });
      }
    },
    async [Actions.HandMyEventVoteNone](context: any, payload: any) {
      var partId = payload.EventParticipantId;
      var data: invitePersonModel = context.state.EventPartRespStatus;
      data.Status = payload.Status;
      var endPoint = config.apiEndPoints.jma + apiEnums.PutEventResponseNone.Path;
      // console.log("Actions.HandMyEventVoteNone", payload)
      // console.log("Actions.HandMyEventVoteNone data ", data)

      await axios
        .put(
          endPoint.replace(
            apiEnums.PutEventResponseNone.Params.participantid,
            partId
          ),
          payload
        )
        .then((response) => {

          if (~~(response.status / 100) == 2) {
            // console.log("----------------------------------------");

            //console.log()

          }
        })
        .catch((error: any) => {

          console.log({
            endpoint: endPoint,
            path: endPoint.replace(config.apiEndPoints.jma, ""),
            request: payload,
          });
        });


    }
  },

  getters: {
    [Getters.MyEventsAvailableDays](context: any) {
      return context.MyParticipationEventsAvailableTimes;
    },
    [Getters.MyEventsResponses](context: any) {
      context.MyParticipationEventsResponses.sort(function (
        a: voteEventModel,
        b: voteEventModel
      ) {
        let titleA = a.EventHeaderId;
        let titleB = b.EventHeaderId;

        if (titleA > titleB) {
          return 1;
        }
        if (titleA < titleB) {
          return -1;
        }

        let keyA = dayjs(a.ScheduleStartUTCDateTime)
          .startOf("day")
          .toDate()
          .getTime();
        let keyB = dayjs(b.ScheduleStartUTCDateTime)
          .startOf("day")
          .toDate()
          .getTime();

        if (keyA > keyB) {
          return 1;
        }
        if (keyA < keyB) {
          return -1;
        }
        return 0;
      });
      return context.MyParticipationEventsResponses;
    },
    [Getters.EventSchedularCountWithMyResponse]:
      (context: any) => (sorttype: string) => {
        if (
          context.EventSchedularCountWithMyResponse &&
          context.EventSchedularCountWithMyResponse.length
        ) {
          context.EventSchedularCountWithMyResponse.sort(function (
            a: voteEventCountModel,
            b: voteEventCountModel
          ) {
            switch (sorttype) {
              case Params.SortByStartTime: //order by time
                let keyA = a.ScheduleStartUTCDateTime,
                  keyB = b.ScheduleStartUTCDateTime;
                if (keyA > keyB) return 1;
                if (keyA < keyB) return -1;
                if (a.AgreeCount != b.AgreeCount) {
                  return b.AgreeCount - a.AgreeCount;
                }
                return 0;
              case Params.SortByAgreeCount:
              default:
                //order by agree
                if (a.AgreeCount != b.AgreeCount) {
                  return b.AgreeCount - a.AgreeCount;
                } else {
                  let keyA = a.ScheduleStartUTCDateTime,
                    keyB = b.ScheduleStartUTCDateTime;
                  if (keyA > keyB) return 1;
                  if (keyA < keyB) return -1;
                  return 0;
                }
            }
          });
        }
        return context.EventSchedularCountWithMyResponse;
      },
    [Getters.TimelineRowGroupHeaderList]:
      (context: any) => (ori: Array<statusModel>) => {
        let result = <Array<timelineRowGroupHeaderModel>>ori.map(function (
          status: statusModel
        ) {
          let item = <timelineRowGroupHeaderModel>{
            Text: status.Name,
            Value: status.Value,
            ShowDetail: true,
          };

          switch (item.Value) {
            case ParamEventStatus.Open:
              item.StyleColor = "#7fd6ff";
              break;
            case ParamEventStatus.Close:
              item.StyleColor = "#ffcb33";
              break;
            default:
              item.StyleColor = "#dc0005";
          }

          return item;
        });
        return result;
      },
    [Getters.TimelineRowHeaderList]:
      (context: any) => (ori: Array<inviteEventModel>) => {
        let result = <Array<timelineRowHeaderModel>>ori.map(function (
          event: inviteEventModel
        ) {
          let item = <timelineRowHeaderModel>{
            Group: event.Status,
            Value: event.EventHeaderId.toUpperCase(),
            Text: event.Title,
            StyleColor: stc(event.EventHeaderId),
          };

          return item;
        });
        return result;
      },
    [Getters.TimelineDataList]:
      (context: any) =>
        (
          eventData: Array<inviteEventModel>,
          schedularData: Array<inviteSchedulerModel>,
          userResponse: Array<voteEventModel>,
          showDay: number,
          baseDate: Date
        ) => {
          let resArray = <Array<timelineElmtModel>>[];
          let day = baseDate.getDay();
          let diff = baseDate.getDate() - day + (day == 0 ? -6 : 1);
          let theFirstDate = new Date(
            new Date(baseDate).setDate(diff)
          ).toISOString();
          let theLastDate = new Date(
            new Date(baseDate).setDate(diff) + (showDay - 1) * 86400000
          ).toISOString();
          let pointer: number = 0;
          let counter: number = 0;
          let currentafter: boolean = false;
          let currentbefore: boolean = false;
          let size =
            dayjs(theLastDate)
              .startOf("day")
              .diff(dayjs(theFirstDate).startOf("day"), "day") + 1;
          let localSchedularData = schedularData.map(
            (a: inviteSchedulerModel) => {
              return { ...a };
            }
          );
          let localUserResponse = userResponse.map((a: voteEventModel) => {
            return { ...a };
          });

          localSchedularData.sort(function (
            a: inviteSchedulerModel,
            b: inviteSchedulerModel
          ) {
            if (a.EventHeaderId === b.EventHeaderId) {
              return a.ScheduleStartUTCDateTime < b.ScheduleStartUTCDateTime
                ? -1
                : 1;
            } else {
              return a.EventHeaderId < b.EventHeaderId ? -1 : 1;
            }
          });
          localUserResponse.sort(function (a: voteEventModel, b: voteEventModel) {
            if (a.EventHeaderId === b.EventHeaderId) {
              return a.ScheduleStartUTCDateTime < b.ScheduleStartUTCDateTime
                ? -1
                : 1;
            } else {
              return a.EventHeaderId < b.EventHeaderId ? -1 : 1;
            }
          });

          //For Event Schedular
          resArray.push({});
          //For User Response
          resArray.push({});
          eventData.forEach(function (row: inviteEventModel) {
            let id = row.EventHeaderId.toUpperCase();
            let status = row.Status;

            resArray[0][id] = {};
            resArray[1][id] = {};
            if (
              status == ParamEventStatus.Close &&
              dayjs(row.StartUTCDateTime).isSameOrBefore(theLastDate, "day") &&
              dayjs(row.EndUTCDateTime).isSameOrAfter(theFirstDate, "day")
            ) {
              let dx: number = dayjs(row.StartUTCDateTime).isBefore(
                theFirstDate,
                "day"
              )
                ? 0
                : dayjs(row.StartUTCDateTime)
                  .startOf("day")
                  .diff(dayjs(theFirstDate).startOf("day"), "day");
              let cnt: number =
                dayjs(
                  dayjs(row.EndUTCDateTime).isAfter(theLastDate, "day")
                    ? theLastDate
                    : row.EndUTCDateTime
                )
                  .startOf("day")
                  .diff(
                    dayjs(
                      dayjs(row.StartUTCDateTime).isBefore(theFirstDate, "day")
                        ? theFirstDate
                        : row.StartUTCDateTime
                    ).startOf("day"),
                    "day"
                  ) + 1;
              let after: boolean = dayjs(row.EndUTCDateTime).isAfter(
                theLastDate,
                "day"
              );
              let before: boolean = dayjs(row.StartUTCDateTime).isBefore(
                theFirstDate,
                "day"
              );

              if (dx > pointer + counter) {
                pointer = dx;
                counter = cnt;
                currentafter = after;
                currentbefore = before;
              } else {
                cnt = dx + cnt - pointer;
                if (counter < cnt) counter = cnt;
                else cnt = counter;
                dx = pointer;
                currentafter = currentafter || after;
                currentbefore = currentbefore || before;
              }

              if (counter + dx > size) {
                counter = size - dx;
              }

              if (!Object.prototype.hasOwnProperty.call(resArray[0][id], dx)) {
                resArray[0][id][dx] = {};
                resArray[1][id][dx] = {};
              }
              resArray[0][id][dx]["complete"] = <
                {
                  length: number;
                  isBefore: boolean;
                  isAfter: boolean;
                  isAlpha: boolean;
                }
                >{
                  length: counter,
                  isAfter: currentafter,
                  isBefore: currentbefore,
                  isAlpha: Boolean(false),
                };
              resArray[1][id][dx]["complete"] = <
                {
                  length: number;
                  isBefore: boolean;
                  isAfter: boolean;
                  isAlpha: boolean;
                }
                >{
                  length: counter,
                  isAfter: currentafter,
                  isBefore: currentbefore,
                  isAlpha: Boolean(false),
                };
            }
          });

          //reset
          let tempId = "";
          let entStatus = "";
          localSchedularData.forEach(function (elmt: inviteSchedulerModel) {
            let id = elmt.EventHeaderId.toUpperCase();

            if (tempId != id) {
              pointer = 0;
              counter = 0;
              currentafter = false;
              currentbefore = false;
              tempId = id;
              entStatus =
                eventData.find(function (x: inviteEventModel) {
                  return x.EventHeaderId.toUpperCase() == tempId;
                })?.Status ?? ParamEventStatus.Open;
            }

            //確認EVENT存在，且該狀態不是結束
            if (
              Object.prototype.hasOwnProperty.call(resArray[0], id) &&
              entStatus != ParamEventStatus.Close
            ) {
              if (
                dayjs(elmt.ScheduleStartUTCDateTime).isBefore(
                  theLastDate,
                  "day"
                ) &&
                dayjs(elmt.ScheduleEndUTCDateTime).isSameOrAfter(
                  theFirstDate,
                  "day"
                )
              ) {
                let dx: number = dayjs(elmt.ScheduleStartUTCDateTime).isBefore(
                  theFirstDate,
                  "day"
                )
                  ? 0
                  : dayjs(elmt.ScheduleStartUTCDateTime)
                    .startOf("day")
                    .diff(dayjs(theFirstDate).startOf("day"), "day");
                let cnt: number =
                  dayjs(
                    dayjs(elmt.ScheduleEndUTCDateTime).isAfter(
                      theLastDate,
                      "day"
                    )
                      ? theLastDate
                      : elmt.ScheduleEndUTCDateTime
                  )
                    .startOf("day")
                    .diff(
                      dayjs(
                        dayjs(elmt.ScheduleStartUTCDateTime).isBefore(
                          theFirstDate,
                          "day"
                        )
                          ? theFirstDate
                          : elmt.ScheduleStartUTCDateTime
                      ).startOf("day"),
                      "day"
                    ) + 1;
                let after: boolean = dayjs(elmt.ScheduleEndUTCDateTime).isAfter(
                  theLastDate,
                  "day"
                );
                let before: boolean = dayjs(
                  elmt.ScheduleStartUTCDateTime
                ).isBefore(theFirstDate, "day");

                if (dx > pointer + counter) {
                  pointer = dx;
                  counter = cnt;
                  currentafter = after;
                  currentbefore = before;
                } else {
                  cnt = dx + cnt - pointer;
                  if (counter < cnt) counter = cnt;
                  else cnt = counter;
                  dx = pointer;
                  currentafter = currentafter || after;
                  currentbefore = currentbefore || before;
                }

                if (counter + dx > size) {
                  counter = size - dx;
                }

                resArray[0][id][dx] = {
                  choice: <
                    {
                      length: number;
                      isBefore: boolean;
                      isAfter: boolean;
                      isAlpha: boolean;
                    }
                    >{
                      length: counter,
                      isAfter: currentafter,
                      isBefore: currentbefore,
                      isAlpha: true,
                    },
                };
              }
            }
          });

          tempId = "";
          entStatus = "";
          localUserResponse.forEach(function (elmt: voteEventModel) {
            if (elmt.Status == ParamResponseStatus.Agree) {
              let id = elmt.EventHeaderId.toUpperCase();
              if (tempId != id) {
                pointer = 0;
                counter = 0;
                currentafter = false;
                currentbefore = false;
                tempId = id;
                entStatus =
                  eventData.find(function (x: inviteEventModel) {
                    return x.EventHeaderId.toUpperCase() == tempId;
                  })?.Status ?? ParamEventStatus.Open;
              }

              //確認EVENT存在，且該狀態不是結束
              if (
                Object.prototype.hasOwnProperty.call(resArray[1], id) &&
                entStatus != ParamEventStatus.Close
              ) {
                if (
                  dayjs(elmt.ScheduleStartUTCDateTime).isBefore(
                    theLastDate,
                    "day"
                  ) &&
                  dayjs(elmt.ScheduleEndUTCDateTime).isSameOrAfter(
                    theFirstDate,
                    "day"
                  )
                ) {
                  let dx: number = dayjs(elmt.ScheduleStartUTCDateTime).isBefore(
                    theFirstDate,
                    "day"
                  )
                    ? 0
                    : dayjs(elmt.ScheduleStartUTCDateTime)
                      .startOf("day")
                      .diff(dayjs(theFirstDate).startOf("day"), "day");
                  let cnt: number =
                    dayjs(
                      dayjs(elmt.ScheduleEndUTCDateTime).isAfter(
                        theLastDate,
                        "day"
                      )
                        ? theLastDate
                        : elmt.ScheduleEndUTCDateTime
                    )
                      .startOf("day")
                      .diff(
                        dayjs(
                          dayjs(elmt.ScheduleStartUTCDateTime).isBefore(
                            theFirstDate,
                            "day"
                          )
                            ? theFirstDate
                            : elmt.ScheduleStartUTCDateTime
                        ).startOf("day"),
                        "day"
                      ) + 1;
                  let after: boolean = dayjs(
                    elmt.ScheduleEndUTCDateTime
                  ).isAfter(theLastDate, "day");
                  let before: boolean = dayjs(
                    elmt.ScheduleStartUTCDateTime
                  ).isBefore(theFirstDate, "day");

                  if (dx > pointer + counter) {
                    pointer = dx;
                    counter = cnt;
                    currentafter = after;
                    currentbefore = before;
                  } else {
                    cnt = dx + cnt - pointer;
                    if (counter < cnt) counter = cnt;
                    else cnt = counter;
                    dx = pointer;
                    currentafter = currentafter || after;
                    currentbefore = currentbefore || before;
                  }

                  if (counter + dx > size) {
                    counter = size - dx;
                  }

                  resArray[1][id][dx] = {
                    choice: <
                      {
                        length: number;
                        isBefore: boolean;
                        isAfter: boolean;
                        isAlpha: boolean;
                      }
                      >{
                        length: counter,
                        isAfter: currentafter,
                        isBefore: currentbefore,
                        isAlpha: false,
                      },
                  };
                }
              }
            }
          });

          return resArray;
        },
    [Getters.EventPartRespStatus](context: any) {
      return context.EventPartRespStatus;
    }
  },
};

export { Module, participationModules };
